import type { FeefoRatingBreakdownResponse } from 'src/services/feefo-api/types/FeefoRatingBreakdownResponse';
import type { ReviewsSummaryRatingBreakdown } from '../types';

export const adaptFeefoRatingBreakdownToStore = (
  response: FeefoRatingBreakdownResponse,
): ReviewsSummaryRatingBreakdown => {
  const { product, rating } = response.rating;

  return {
    averageRating: rating,
    starCounts: {
      1: product['1_star'],
      2: product['2_star'],
      3: product['3_star'],
      4: product['4_star'],
      5: product['5_star'],
    },
    totalCount: product.count,
  };
};
